//import statement
import { useWallet } from '@solana/wallet-adapter-react';
import { useWalletModal } from '@solana/wallet-adapter-react-ui';
import { PublicKey } from '@solana/web3.js';
import { useCallback, useEffect, useState } from 'react';
import {
  Button,
  ButtonGroup,
  Col,
  Container,
  Row,
  Spinner,
  Table,
} from 'react-bootstrap';
import { FaDiscord, FaTwitter } from 'react-icons/fa';
import { useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import ME from '../assets/magiceden.png';
import useApi, { FILE_URL } from '../hooks/useApi';
import useRaffles from '../hooks/useRaffles';
import Footer from '../reuseable/footer';
import Header from '../reuseable/header';
import InfoBar from '../reuseable/infoBar';
import PageName from '../reuseable/pageName';

//functional component
const Raffles = () => {
  const { key } = useParams();
  const { fetchRaffle, buyTickets, fetchMyEntry } = useRaffles();
  const wallet = useWallet();
  const walletModal = useWalletModal();
  const api = useApi();

  const [raffleDetails, setRaffleDetails] = useState(null);
  const [timeToLock, setTimeToLock] = useState('0d 0h 0m 0s');
  const [date, setDate] = useState(new Date());
  const [winners, setWinners] = useState([]);
  const [raffle, setRaffle] = useState(null);
  const [quantity, setQuantity] = useState(1);
  const [myEntry, setMyEntry] = useState();

  const fetchRaffleDetails = useCallback(async () => {
    if (!key) return;
    const data = await fetchRaffle(new PublicKey(key));
    if (!data) return;
    setRaffle(data);
    setWinners(data.participants.filter((part) => part.isWon));
    api.get('rafflesDetails/' + key).then((res) => setRaffleDetails(res.data));
  }, [key, fetchRaffle]);

  useEffect(() => {
    fetchRaffleDetails();
  }, [fetchRaffleDetails]);

  const fetchMyEntryDetails = useCallback(async () => {
    if (!key) return;
    const data = await fetchMyEntry(new PublicKey(key));
    if (!data) return;
    setMyEntry(data);
  }, [key, fetchMyEntry]);

  useEffect(() => {
    fetchMyEntryDetails();
  }, [fetchMyEntryDetails]);

  useEffect(() => {
    if (!raffle) return;
    const now = date;
    const limit = raffle?.isStarted ? raffle?.end : raffle?.start;
    let milliseconds = limit.getTime() - now.getTime();
    if (milliseconds < 0) {
      if (raffle.isStarted) {
        raffle.isClosed = true;
      } else {
        raffle.isStarted = true;
      }
    } else {
      let seconds = milliseconds / 1000;
      let minutes = seconds / 60;
      let hours = minutes / 60;
      let days = Math.floor(hours / 24);
      seconds = Math.floor(seconds % 60);
      minutes = Math.floor(minutes % 60);
      hours = Math.floor(hours % 24);
      setTimeToLock(`${days}d ${hours}h ${minutes}m ${seconds}s`);
      if (raffle.isStarted) {
        raffle.isClosed = false;
      }
    }

    const interval = setInterval(() => {
      if (raffle) {
        setDate(new Date());
      }
    }, 1000);
    return () => clearInterval(interval);
  }, [raffle, date]);

  // QUANTITY CHANGE
  const handleQuantityChange = (e) => {
    const qty = e?.target?.value || e;

    if (raffle.maxTickets > 0) {
      if (raffle.tickets + qty > raffle.maxTickets) {
        setQuantity(raffle.maxTickets);
      }
    }
  };

  const buyTikets = async () => {
    if (!wallet.connected) {
      console.log('Wallet not connected!');
      return walletModal.setVisible(true);
    }

    // PROMPT FOR AMOUNT TO BUY
    const data = await api
      .get(`get_profile/${wallet.publicKey.toString()}`)
      .catch((e) => null);

    // GETTING USER DISCORD ID
    const discordId = data?.data?.discordId;

    // CONDITIONAL CHECK FOR DISCORD ID
    if (raffle.raffleType !== 'NFT' && !discordId) {
      let id = prompt('Enter your discord id');
      if (id.length > 0) {
        // INSERTING ID INTO DB
        api
          .post('profile', {
            discordId: id,
            wallet_address: wallet.publicKey?.toString(),
          })
          .then(async (res) => {
            toast.success('Successfully added your discord ID!');
          })
          .catch((err) => toast.error(err.message));
      }
    }

    await buyTickets(new PublicKey(key), quantity);
    fetchRaffleDetails();
  };

  //check if wallet is connected
  const isDisable = wallet.connected ? false : true;
  return (
    <div className='raffle-page bg-dark'>
      {/* <div>
                { minutes === 0 && seconds === 0
                    ? null
                    : <h1> { days }: { hours < 10 ? `0${ hours }` : hours }:{ minutes < 10 ? `0${ minutes }` : minutes } : { seconds < 10 ? `0${ seconds }` : seconds }</h1>
                }
            </div> */}
      <Container>
        <Header />
        <PageName name='Back' backArrow={'show'} />
        {raffle ? (
          <>
            <InfoBar
              tickets={raffle?.tickets}
              spent={(raffle?.tickets * raffle?.price).toFixed(1)}
              wallets={raffle?.participants?.length}
            />
            <div className='detailed-card'>
              <div className='name'>
                <h1> {raffle?.name}</h1>
                {raffleDetails?.twitter && (
                  <a href={raffleDetails?.twitter} target='_blank'>
                    <FaDiscord color='white' className='mx-3' size={25} />
                  </a>
                )}
                {raffleDetails?.discord && (
                  <a href={raffleDetails?.discord} target='_blank'>
                    <FaTwitter color='white' className='mx-1' size={25} />
                  </a>
                )}
                {raffleDetails?.magicEden && (
                  <a href={raffleDetails?.magicEden} target='_blank'>
                    {' '}
                    <img
                      src={ME}
                      className='mx-1'
                      alt='logo'
                      height={18}
                    />{' '}
                  </a>
                )}
              </div>
              <Row className='my-4 justify-content-center'>
                <Col lg='4' md='12' sm='12' xs='12'>
                  {raffle.key.toString() ===
                  '4t5VtY2thiXM1E2hPRu4YoLKdoz6iaMf3bkb5McRmcKH' ? (
                    <img
                      alt='raffle'
                      src='/temples_raffle.webp'
                      height={'auto'}
                      width={'100%'}
                      style={{ height: '100%', objectFit: 'contain' }}
                    />
                  ) : (
                    <img
                      alt='raffle'
                      src={FILE_URL + raffle.image}
                      height={'auto'}
                      width={'100%'}
                      style={{ height: '100%', objectFit: 'contain' }}
                    />
                  )}
                </Col>
                <Col
                  lg='8'
                  md='12'
                  sm='12'
                  xs='12'
                  className='raffles_descripion'
                >
                  <Row>
                    <Col lg='6' md='6' sm='12' xs='12'>
                      <div className='details'>
                        <h6>Price</h6>
                        <p>{raffle.price.toFixed(1)} $GOD</p>
                        {!raffle.isClosed && (
                          <>
                            <h6>Total</h6>
                            <p>{(raffle?.price * quantity).toFixed(1)} $GOD</p>
                            {raffle.maxTickets > 0 && (
                              <>
                                <h6>Available Tickets</h6>
                                <p>{raffle.maxTickets - quantity}</p>
                              </>
                            )}
                            {raffle.maxTicketsPerPerson != 999999 && (
                              <>
                                <h6>Limits</h6>
                                <p>{raffle.maxTicketsPerPerson} / User</p>
                              </>
                            )}
                          </>
                        )}
                      </div>
                    </Col>
                    <Col lg='6' md='6' sm='12' xs='12'>
                      {!raffle?.isClosed && (
                        <>
                          <h5>RAFFLE {raffle.isStarted ? 'ENDS' : 'STARTS'}</h5>
                          <p>{timeToLock}</p>
                          {!(
                            (raffle.maxTickets > 0 &&
                              myEntry?.tickets === raffle.maxTickets) ||
                            (raffle.maxTicketsPerPerson > 0 &&
                              myEntry?.tickets === raffle.maxTicketsPerPerson)
                          ) ? (
                            raffle.isStarted && (
                              <>
                                <ButtonGroup className='quantity'>
                                  <Button
                                    variant='outline-light'
                                    onClick={() => {
                                      if (quantity > 1)
                                        setQuantity(quantity - 1);
                                    }}
                                  >
                                    -
                                  </Button>
                                  <input
                                    disabled={isDisable}
                                    value={quantity}
                                    type='number'
                                    style={{ width: '50px' }}
                                    onChange={(e) =>
                                      setQuantity(
                                        Math.min(
                                          parseInt(e.target.value),
                                          raffle.maxTicketsPerPerson -
                                            (myEntry?.tickets || 0)
                                        )
                                      )
                                    }
                                  />

                                  <Button
                                    variant='outline-light'
                                    onClick={() =>
                                      setQuantity(
                                        Math.min(
                                          quantity + 1,
                                          raffle.maxTicketsPerPerson -
                                            (myEntry?.tickets || 0)
                                        )
                                      )
                                    }
                                  >
                                    +
                                  </Button>
                                </ButtonGroup>
                                <div className='mt-3'>
                                  <Button
                                    variant='outline-danger'
                                    onClick={buyTikets}
                                  >
                                    {' '}
                                    {!wallet.connected
                                      ? 'Connect Wallet'
                                      : 'Buy Tickets'}
                                  </Button>
                                </div>
                              </>
                            )
                          ) : (
                            <p
                              className='text-danger'
                              style={{ fontFamily: 'Besan' }}
                            >
                              Your buying limit has been Reached
                            </p>
                          )}
                        </>
                      )}
                    </Col>
                    <Col
                      lg='12'
                      md='12'
                      sm='12'
                      xs='12'
                      className='details_wrapper'
                    >
                      <h3>{raffleDetails?.descriptionTitle}</h3>
                      <p>{raffleDetails?.description}</p>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </div>
          </>
        ) : (
          <div className='bg-spinner'>
            {' '}
            <Spinner animation='border' variant='light' size='lg' />
          </div>
        )}
        {raffle?.isClosed ? (
          <Row className='tokens justify-content-center'>
            <h3 className='text-center '>Winners</h3>

            <Col className='winners-table' xs='12' md='8'>
              <Table responsive>
                <thead className='ml-3'>
                  <tr>
                    <th>Winners</th>
                    <th>Tickets</th>
                    <th>Total</th>
                  </tr>
                </thead>
                <tbody>
                  {winners?.map((val, index) => {
                    return (
                      <tr key={index}>
                        <td>{val?.owner.toString()}</td>
                        <td>{val?.tickets}</td>
                        <td>{(val?.tickets * raffle?.price).toFixed(1)}</td>
                      </tr>
                    );
                  })}
                </tbody>
              </Table>
            </Col>
          </Row>
        ) : null}
        {myEntry ? (
          <Row className='tokens justify-content-center'>
            <h3 className='text-center '>My Entries</h3>

            <Col className='winners-table' xs='12' md='8'>
              <Table responsive>
                <thead className='ml-3'>
                  <tr>
                    <th>Wallet</th>
                    <th>Tickets</th>
                    <th>Total</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>{myEntry?.owner?.toString()}</td>
                    <td> {myEntry?.tickets}</td>
                    <td>{(myEntry?.tickets * raffle?.price).toFixed(1)}</td>
                  </tr>
                </tbody>
              </Table>
            </Col>
          </Row>
        ) : null}
        <Footer />
      </Container>
    </div>
  );
};
export default Raffles;
